import { LicenceId } from '@ps/platform-message-framework/common/LicenceId';
import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import { StarsInfo } from '@ps/web-shared-ui';
import React from 'react';
import { useSelector } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import { select } from '@swf/core/store';

import {
  TXTCLI_Michigan_Gaming_Control_Board__ELL,
  TXTCLI_Michigan_Gaming_Control_Board__ELL_1,
  TXTCLI_New_Jersey_Division_of_Gaming__ELL,
  TXTCLI_Pennsylvania_Gaming_Control_Bo_ELL,
  TXTCLI_You_may_change_these_details_o_ELL,
  TXTCLI_You_may_change_these_details_o_ELL_1,
  TXTWCL_For_further_information_about__ELL,
  TXTWCL_New_Jersey_Division_of_Gaming__ELL,
  TXTWCL_Pennsylvania_Gaming_Control_Bo_ELL
} from './SelfExclusionMessage.messages.json';

interface Props {
  className?: string;
  divisionName: string;
  isAddress?: boolean;
}

const textForLicense = {
  [LicenceId.USNJ]: {
    accountDetails: TXTWCL_New_Jersey_Division_of_Gaming__ELL,
    responsibleGaming: TXTCLI_New_Jersey_Division_of_Gaming__ELL
  },
  [LicenceId.USPA]: {
    accountDetails: TXTWCL_Pennsylvania_Gaming_Control_Bo_ELL,
    responsibleGaming: TXTCLI_Pennsylvania_Gaming_Control_Bo_ELL
  },
  [LicenceId.USMI]: {
    accountDetails: TXTCLI_Michigan_Gaming_Control_Board__ELL_1,
    responsibleGaming: TXTCLI_Michigan_Gaming_Control_Board__ELL
  }
};

export const SelfExclusionMessage: React.FC<Props> = ({ className, divisionName, isAddress }) => {
  const license = useSelector(select.account.getLicense);
  const isUSMIaddressChangeNotAllowed = license === LicenceId.USMI && isAddress;

  return (
    <StarsInfo type="error" className={className}>
      {/* @ts-expect-error - Type issue was not resolved prior to TS5 upgrade. */}
      <Translation {...textForLicense[license][divisionName]} />{' '}
      <Translation
        {...(isUSMIaddressChangeNotAllowed
          ? TXTCLI_You_may_change_these_details_o_ELL_1
          : TXTCLI_You_may_change_these_details_o_ELL)}
      />{' '}
      <Translation
        {...TXTWCL_For_further_information_about__ELL}
        values={{
          a: (msg: React.ReactNode) => (
            <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
          )
        }}
      />
    </StarsInfo>
  );
};

export default SelfExclusionMessage;
